// GENERATED FILE, PLEASE DO NOT EDIT
var iconDefinitions = [{
  name: 'Add',
  fileName: 'add',
  sizes: ['16', '24']
}, {
  name: 'AddCircleFill',
  fileName: 'add-circle-fill',
  sizes: ['16', '24']
}, {
  name: 'AddCircleLine',
  fileName: 'add-circle-line',
  sizes: ['16', '24']
}, {
  name: 'AddSquareFill',
  fileName: 'add-square-fill',
  sizes: ['16', '24']
}, {
  name: 'AddSquareLine',
  fileName: 'add-square-line',
  sizes: ['16', '24']
}, {
  name: 'AirPumpFill',
  fileName: 'air-pump-fill',
  sizes: ['16', '24']
}, {
  name: 'AirPumpLine',
  fileName: 'air-pump-line',
  sizes: ['16', '24']
}, {
  name: 'AlcoholLine',
  fileName: 'alcohol-line',
  sizes: ['24']
}, {
  name: 'AlignTopFill',
  fileName: 'align-top-fill',
  sizes: ['16', '24']
}, {
  name: 'AlignTopLine',
  fileName: 'align-top-line',
  sizes: ['16', '24']
}, {
  name: 'ArrowDoubleDown',
  fileName: 'arrow-double-down',
  sizes: ['16', '24']
}, {
  name: 'ArrowDoubleDownLeft',
  fileName: 'arrow-double-down-left',
  sizes: ['16', '24']
}, {
  name: 'ArrowDoubleDownRight',
  fileName: 'arrow-double-down-right',
  sizes: ['16', '24']
}, {
  name: 'ArrowDoubleLeft',
  fileName: 'arrow-double-left',
  sizes: ['16', '24']
}, {
  name: 'ArrowDoubleRight',
  fileName: 'arrow-double-right',
  sizes: ['16', '24']
}, {
  name: 'ArrowDoubleUp',
  fileName: 'arrow-double-up',
  sizes: ['16', '24']
}, {
  name: 'ArrowDoubleUpLeft',
  fileName: 'arrow-double-up-left',
  sizes: ['16', '24']
}, {
  name: 'ArrowDoubleUpRight',
  fileName: 'arrow-double-up-right',
  sizes: ['16', '24']
}, {
  name: 'ArrowDown',
  fileName: 'arrow-down',
  sizes: ['16', '24']
}, {
  name: 'ArrowDownLeft',
  fileName: 'arrow-down-left',
  sizes: ['16', '24']
}, {
  name: 'ArrowDownRight',
  fileName: 'arrow-down-right',
  sizes: ['16', '24']
}, {
  name: 'ArrowHorizontalVertical',
  fileName: 'arrow-horizontal-vertical',
  sizes: ['16', '24']
}, {
  name: 'ArrowLeft',
  fileName: 'arrow-left',
  sizes: ['16', '24']
}, {
  name: 'ArrowRight',
  fileName: 'arrow-right',
  sizes: ['16', '24']
}, {
  name: 'ArrowTurnLeft',
  fileName: 'arrow-turn-left',
  sizes: ['16', '24']
}, {
  name: 'ArrowTurnRight',
  fileName: 'arrow-turn-right',
  sizes: ['16', '24']
}, {
  name: 'ArrowUp',
  fileName: 'arrow-up',
  sizes: ['16', '24']
}, {
  name: 'ArrowUpLeft',
  fileName: 'arrow-up-left',
  sizes: ['16', '24']
}, {
  name: 'ArrowUpRight',
  fileName: 'arrow-up-right',
  sizes: ['16', '24']
}, {
  name: 'BadgeAFill',
  fileName: 'badge-A-fill',
  sizes: ['16', '24']
}, {
  name: 'BadgeALine',
  fileName: 'badge-A-line',
  sizes: ['16', '24']
}, {
  name: 'BadgeBFill',
  fileName: 'badge-B-fill',
  sizes: ['16', '24']
}, {
  name: 'BadgeBLine',
  fileName: 'badge-B-line',
  sizes: ['16', '24']
}, {
  name: 'BadgeCFill',
  fileName: 'badge-C-fill',
  sizes: ['16', '24']
}, {
  name: 'BadgeCLine',
  fileName: 'badge-C-line',
  sizes: ['16', '24']
}, {
  name: 'BadgeDFill',
  fileName: 'badge-D-fill',
  sizes: ['16', '24']
}, {
  name: 'BadgeDLine',
  fileName: 'badge-D-line',
  sizes: ['16', '24']
}, {
  name: 'BeakerFill',
  fileName: 'beaker-fill',
  sizes: ['16', '24']
}, {
  name: 'BeakerLine',
  fileName: 'beaker-line',
  sizes: ['16', '24']
}, {
  name: 'BidFill',
  fileName: 'bid-fill',
  sizes: ['16', '24']
}, {
  name: 'BidLine',
  fileName: 'bid-line',
  sizes: ['16', '24']
}, {
  name: 'BlobAlmondblob',
  fileName: 'blob-almondblob',
  sizes: ['16', '24']
}, {
  name: 'BlobAvoblob',
  fileName: 'blob-avoblob',
  sizes: ['16', '24']
}, {
  name: 'BlobMusselblob',
  fileName: 'blob-musselblob',
  sizes: ['16', '24']
}, {
  name: 'BlobPearblob',
  fileName: 'blob-pearblob',
  sizes: ['16', '24']
}, {
  name: 'BlobRibsblob',
  fileName: 'blob-ribsblob',
  sizes: ['16', '24']
}, {
  name: 'BlobSteakblob',
  fileName: 'blob-steakblob',
  sizes: ['16', '24']
}, {
  name: 'BoltFill',
  fileName: 'bolt-fill',
  sizes: ['16', '24']
}, {
  name: 'BoltLine',
  fileName: 'bolt-line',
  sizes: ['16', '24']
}, {
  name: 'BookmarkFill',
  fileName: 'bookmark-fill',
  sizes: ['16', '24']
}, {
  name: 'BookmarkFillLight',
  fileName: 'bookmark-fill-light',
  sizes: ['16', '24']
}, {
  name: 'BookmarkLine',
  fileName: 'bookmark-line',
  sizes: ['16', '24']
}, {
  name: 'BookmarkLineLight',
  fileName: 'bookmark-line-light',
  sizes: ['16', '24']
}, {
  name: 'BrowseFill',
  fileName: 'browse-fill',
  sizes: ['16', '24']
}, {
  name: 'BrowseLine',
  fileName: 'browse-line',
  sizes: ['16', '24']
}, {
  name: 'BrowseTabLine',
  fileName: 'browse-tab-line',
  sizes: ['16', '24']
}, {
  name: 'CalendarAddFill',
  fileName: 'calendar-add-fill',
  sizes: ['16', '24']
}, {
  name: 'CalendarAddLine',
  fileName: 'calendar-add-line',
  sizes: ['16', '24']
}, {
  name: 'CalendarCancelFill',
  fileName: 'calendar-cancel-fill',
  sizes: ['16', '24']
}, {
  name: 'CalendarCancelLine',
  fileName: 'calendar-cancel-line',
  sizes: ['16', '24']
}, {
  name: 'CalendarCheckFill',
  fileName: 'calendar-check-fill',
  sizes: ['16', '24']
}, {
  name: 'CalendarCheckLine',
  fileName: 'calendar-check-line',
  sizes: ['16', '24']
}, {
  name: 'CalendarFill',
  fileName: 'calendar-fill',
  sizes: ['16', '24']
}, {
  name: 'CalendarLine',
  fileName: 'calendar-line',
  sizes: ['16', '24']
}, {
  name: 'CallCustomer',
  fileName: 'call-customer',
  sizes: ['24']
}, {
  name: 'CallCustomerFill',
  fileName: 'call-customer-fill',
  sizes: ['24']
}, {
  name: 'CallCustomerLine',
  fileName: 'call-customer-line',
  sizes: ['24']
}, {
  name: 'CallDasher',
  fileName: 'call-dasher',
  sizes: ['24']
}, {
  name: 'CallDasherFill',
  fileName: 'call-dasher-fill',
  sizes: ['24']
}, {
  name: 'CallDasherLine',
  fileName: 'call-dasher-line',
  sizes: ['24']
}, {
  name: 'CallMerchant',
  fileName: 'call-merchant',
  sizes: ['24']
}, {
  name: 'CallMerchantFill',
  fileName: 'call-merchant-fill',
  sizes: ['24']
}, {
  name: 'CallMerchantLine',
  fileName: 'call-merchant-line',
  sizes: ['24']
}, {
  name: 'CallOffice',
  fileName: 'call-office',
  sizes: ['24']
}, {
  name: 'CallOfficeFill',
  fileName: 'call-office-fill',
  sizes: ['24']
}, {
  name: 'CallOfficeLine',
  fileName: 'call-office-line',
  sizes: ['24']
}, {
  name: 'CameraFill',
  fileName: 'camera-fill',
  sizes: ['16', '24']
}, {
  name: 'CameraLine',
  fileName: 'camera-line',
  sizes: ['16', '24']
}, {
  name: 'CardAmexColor',
  fileName: 'card-amex-color',
  sizes: ['16', '24']
}, {
  name: 'CardAmexMonocolor',
  fileName: 'card-amex-monocolor',
  sizes: ['16', '24']
}, {
  name: 'CardApplePayColor',
  fileName: 'card-apple-pay-color',
  sizes: ['16', '24']
}, {
  name: 'CardApplePayMonocolor',
  fileName: 'card-apple-pay-monocolor',
  sizes: ['16', '24']
}, {
  name: 'CardCaviarColor',
  fileName: 'card-caviar-color',
  sizes: ['16', '24']
}, {
  name: 'CardCaviarMonocolor',
  fileName: 'card-caviar-monocolor',
  sizes: ['16', '24']
}, {
  name: 'CardChaseColor',
  fileName: 'card-chase-color',
  sizes: ['16', '24']
}, {
  name: 'CardChaseMonocolor',
  fileName: 'card-chase-monocolor',
  sizes: ['16', '24']
}, {
  name: 'CardDinersClubColor',
  fileName: 'card-diners-club-color',
  sizes: ['16', '24']
}, {
  name: 'CardDinersClubMonocolor',
  fileName: 'card-diners-club-monocolor',
  sizes: ['16', '24']
}, {
  name: 'CardDiscoverColor',
  fileName: 'card-discover-color',
  sizes: ['16', '24']
}, {
  name: 'CardDiscoverMonocolor',
  fileName: 'card-discover-monocolor',
  sizes: ['16', '24']
}, {
  name: 'CardDoordashColor',
  fileName: 'card-doordash-color',
  sizes: ['16', '24']
}, {
  name: 'CardDoordashMonocolor',
  fileName: 'card-doordash-monocolor',
  sizes: ['16', '24']
}, {
  name: 'CardDoordashRewardsColor',
  fileName: 'card-doordash-rewards-color',
  sizes: ['16', '24']
}, {
  name: 'CardDoordashRewardsMonocolor',
  fileName: 'card-doordash-rewards-monocolor',
  sizes: ['16', '24']
}, {
  name: 'CardFill',
  fileName: 'card-fill',
  sizes: ['16', '24']
}, {
  name: 'CardGooglePayColor',
  fileName: 'card-google-pay-color',
  sizes: ['16', '24']
}, {
  name: 'CardGooglePayMonocolor',
  fileName: 'card-google-pay-monocolor',
  sizes: ['16', '24']
}, {
  name: 'CardIdFill',
  fileName: 'card-id-fill',
  sizes: ['16', '24']
}, {
  name: 'CardIdLine',
  fileName: 'card-id-line',
  sizes: ['16', '24']
}, {
  name: 'CardLine',
  fileName: 'card-line',
  sizes: ['16', '24']
}, {
  name: 'CardLoyaltyFill',
  fileName: 'card-loyalty-fill',
  sizes: ['16', '24']
}, {
  name: 'CardLoyaltyLine',
  fileName: 'card-loyalty-line',
  sizes: ['16', '24']
}, {
  name: 'CardMastercardColor',
  fileName: 'card-mastercard-color',
  sizes: ['16', '24']
}, {
  name: 'CardMastercardMonocolor',
  fileName: 'card-mastercard-monocolor',
  sizes: ['16', '24']
}, {
  name: 'CardPaypalColor',
  fileName: 'card-paypal-color',
  sizes: ['16', '24']
}, {
  name: 'CardPaypalMonocolor',
  fileName: 'card-paypal-monocolor',
  sizes: ['16', '24']
}, {
  name: 'CardVenmoColor',
  fileName: 'card-venmo-color',
  sizes: ['16', '24']
}, {
  name: 'CardVenmoMonocolor',
  fileName: 'card-venmo-monocolor',
  sizes: ['16', '24']
}, {
  name: 'CardVisaColor',
  fileName: 'card-visa-color',
  sizes: ['16', '24']
}, {
  name: 'CardVisaMonocolor',
  fileName: 'card-visa-monocolor',
  sizes: ['16', '24']
}, {
  name: 'CaretDown',
  fileName: 'caret-down',
  sizes: ['16', '24']
}, {
  name: 'CaretLeft',
  fileName: 'caret-left',
  sizes: ['16', '24']
}, {
  name: 'CaretRight',
  fileName: 'caret-right',
  sizes: ['16', '24']
}, {
  name: 'CaretUp',
  fileName: 'caret-up',
  sizes: ['16', '24']
}, {
  name: 'CartAddFill',
  fileName: 'cart-add-fill',
  sizes: ['16', '24']
}, {
  name: 'CartAddLine',
  fileName: 'cart-add-line',
  sizes: ['16', '24']
}, {
  name: 'CartFill',
  fileName: 'cart-fill',
  sizes: ['16', '24']
}, {
  name: 'CartLine',
  fileName: 'cart-line',
  sizes: ['16', '24']
}, {
  name: 'CateringFill',
  fileName: 'catering-fill',
  sizes: ['16', '24']
}, {
  name: 'CateringLine',
  fileName: 'catering-line',
  sizes: ['16', '24']
}, {
  name: 'Caviar',
  fileName: 'caviar',
  sizes: ['16', '24']
}, {
  name: 'Challenge',
  fileName: 'challenge',
  sizes: ['16', '24']
}, {
  name: 'ChannelFill',
  fileName: 'channel-fill',
  sizes: ['16', '24']
}, {
  name: 'ChannelLine',
  fileName: 'channel-line',
  sizes: ['16', '24']
}, {
  name: 'ChatConversation',
  fileName: 'chat-conversation',
  sizes: ['24']
}, {
  name: 'ChatCustomer',
  fileName: 'chat-customer',
  sizes: ['24']
}, {
  name: 'ChatDasher',
  fileName: 'chat-dasher',
  sizes: ['24']
}, {
  name: 'ChatDefaultFill',
  fileName: 'chat-default-fill',
  sizes: ['16', '24']
}, {
  name: 'ChatDefaultLine',
  fileName: 'chat-default-line',
  sizes: ['16', '24']
}, {
  name: 'ChatHelp',
  fileName: 'chat-help',
  sizes: ['24']
}, {
  name: 'ChatMerchant',
  fileName: 'chat-merchant',
  sizes: ['24']
}, {
  name: 'ChatOffice',
  fileName: 'chat-office',
  sizes: ['24']
}, {
  name: 'Check',
  fileName: 'check',
  sizes: ['16', '24']
}, {
  name: 'CheckCircleFill',
  fileName: 'check-circle-fill',
  sizes: ['16', '24']
}, {
  name: 'CheckCircleLine',
  fileName: 'check-circle-line',
  sizes: ['16', '24']
}, {
  name: 'CheckSquareFill',
  fileName: 'check-square-fill',
  sizes: ['16', '24']
}, {
  name: 'CheckSquareLine',
  fileName: 'check-square-line',
  sizes: ['16', '24']
}, {
  name: 'CheckSquareOffLine',
  fileName: 'check-square-off-line',
  sizes: ['16', '24']
}, {
  name: 'ChevronDoubleDown',
  fileName: 'chevron-double-down',
  sizes: ['16', '24']
}, {
  name: 'ChevronDoubleLeft',
  fileName: 'chevron-double-left',
  sizes: ['16', '24']
}, {
  name: 'ChevronDoubleRight',
  fileName: 'chevron-double-right',
  sizes: ['16', '24']
}, {
  name: 'ChevronDoubleUp',
  fileName: 'chevron-double-up',
  sizes: ['16', '24']
}, {
  name: 'ChevronDown',
  fileName: 'chevron-down',
  sizes: ['16', '24']
}, {
  name: 'ChevronLeft',
  fileName: 'chevron-left',
  sizes: ['16', '24']
}, {
  name: 'ChevronRight',
  fileName: 'chevron-right',
  sizes: ['16', '24']
}, {
  name: 'ChevronUp',
  fileName: 'chevron-up',
  sizes: ['16', '24']
}, {
  name: 'CityHopperFill',
  fileName: 'city-hopper-fill',
  sizes: ['16', '24']
}, {
  name: 'CityHopperLine',
  fileName: 'city-hopper-line',
  sizes: ['16', '24']
}, {
  name: 'Close',
  fileName: 'close',
  sizes: ['16', '24']
}, {
  name: 'CloseCircleFill',
  fileName: 'close-circle-fill',
  sizes: ['16', '24']
}, {
  name: 'CloseCircleLine',
  fileName: 'close-circle-line',
  sizes: ['16', '24']
}, {
  name: 'CloseSquareFill',
  fileName: 'close-square-fill',
  sizes: ['16', '24']
}, {
  name: 'CloseSquareLine',
  fileName: 'close-square-line',
  sizes: ['16', '24']
}, {
  name: 'Code',
  fileName: 'code',
  sizes: ['16', '24']
}, {
  name: 'CoffeeFill',
  fileName: 'coffee-fill',
  sizes: ['16', '24']
}, {
  name: 'CoffeeLine',
  fileName: 'coffee-line',
  sizes: ['16', '24']
}, {
  name: 'CookingFill',
  fileName: 'cooking-fill',
  sizes: ['16', '24']
}, {
  name: 'CookingLine',
  fileName: 'cooking-line',
  sizes: ['16', '24']
}, {
  name: 'CopyFill',
  fileName: 'copy-fill',
  sizes: ['16', '24']
}, {
  name: 'CopyLine',
  fileName: 'copy-line',
  sizes: ['16', '24']
}, {
  name: 'CropLine',
  fileName: 'crop-line',
  sizes: ['16', '24']
}, {
  name: 'CrownCloverFill',
  fileName: 'crown-clover-fill',
  sizes: ['16', '24']
}, {
  name: 'CrownCloverLine',
  fileName: 'crown-clover-line',
  sizes: ['16', '24']
}, {
  name: 'DashboardFill',
  fileName: 'dashboard-fill',
  sizes: ['16', '24']
}, {
  name: 'DashboardLine',
  fileName: 'dashboard-line',
  sizes: ['16', '24']
}, {
  name: 'DealsFill',
  fileName: 'deals-fill',
  sizes: ['16', '24']
}, {
  name: 'DealsLine',
  fileName: 'deals-line',
  sizes: ['16', '24']
}, {
  name: 'DeliveryTruckFill',
  fileName: 'delivery-truck-fill',
  sizes: ['16', '24']
}, {
  name: 'DeliveryTruckLine',
  fileName: 'delivery-truck-line',
  sizes: ['16', '24']
}, {
  name: 'DevicePhone',
  fileName: 'device-phone',
  sizes: ['16', '24']
}, {
  name: 'DevicePosFill',
  fileName: 'device-pos-fill',
  sizes: ['16', '24']
}, {
  name: 'DevicePosLine',
  fileName: 'device-pos-line',
  sizes: ['16', '24']
}, {
  name: 'DeviceTablet',
  fileName: 'device-tablet',
  sizes: ['16', '24']
}, {
  name: 'DirectionsFill',
  fileName: 'directions-fill',
  sizes: ['16', '24']
}, {
  name: 'DirectionsLine',
  fileName: 'directions-line',
  sizes: ['16', '24']
}, {
  name: 'DockDownLeftLine',
  fileName: 'dock-down-left-line',
  sizes: ['16', '24']
}, {
  name: 'DockDownRightLine',
  fileName: 'dock-down-right-line',
  sizes: ['16', '24']
}, {
  name: 'DockLeftFill',
  fileName: 'dock-left-fill',
  sizes: ['16', '24']
}, {
  name: 'DockLeftLine',
  fileName: 'dock-left-line',
  sizes: ['16', '24']
}, {
  name: 'DockRightFill',
  fileName: 'dock-right-fill',
  sizes: ['16', '24']
}, {
  name: 'DockRightLine',
  fileName: 'dock-right-line',
  sizes: ['16', '24']
}, {
  name: 'DockUpLeftLine',
  fileName: 'dock-up-left-line',
  sizes: ['16', '24']
}, {
  name: 'DockUpRightLine',
  fileName: 'dock-up-right-line',
  sizes: ['16', '24']
}, {
  name: 'DownloadFill',
  fileName: 'download-fill',
  sizes: ['16', '24']
}, {
  name: 'DownloadLine',
  fileName: 'download-line',
  sizes: ['16', '24']
}, {
  name: 'DrinkStrawFill',
  fileName: 'drink-straw-fill',
  sizes: ['16', '24']
}, {
  name: 'DrinkStrawLine',
  fileName: 'drink-straw-line',
  sizes: ['16', '24']
}, {
  name: 'DroneBagFill',
  fileName: 'drone-bag-fill',
  sizes: ['16', '24']
}, {
  name: 'DroneBagLine',
  fileName: 'drone-bag-line',
  sizes: ['16', '24']
}, {
  name: 'DroneLine',
  fileName: 'drone-line',
  sizes: ['16', '24']
}, {
  name: 'EditAddFill',
  fileName: 'edit-add-fill',
  sizes: ['16', '24']
}, {
  name: 'EditAddLine',
  fileName: 'edit-add-line',
  sizes: ['16', '24']
}, {
  name: 'EditFill',
  fileName: 'edit-fill',
  sizes: ['16', '24']
}, {
  name: 'EditLine',
  fileName: 'edit-line',
  sizes: ['16', '24']
}, {
  name: 'EmailFill',
  fileName: 'email-fill',
  sizes: ['16', '24']
}, {
  name: 'EmailLine',
  fileName: 'email-line',
  sizes: ['16', '24']
}, {
  name: 'ErrorFill',
  fileName: 'error-fill',
  sizes: ['16', '24']
}, {
  name: 'ErrorLine',
  fileName: 'error-line',
  sizes: ['16', '24']
}, {
  name: 'EyeHiddenFill',
  fileName: 'eye-hidden-fill',
  sizes: ['16', '24']
}, {
  name: 'EyeHiddenLine',
  fileName: 'eye-hidden-line',
  sizes: ['16', '24']
}, {
  name: 'EyeVisibleFill',
  fileName: 'eye-visible-fill',
  sizes: ['16', '24']
}, {
  name: 'EyeVisibleLine',
  fileName: 'eye-visible-line',
  sizes: ['16', '24']
}, {
  name: 'FavoriteFill',
  fileName: 'favorite-fill',
  sizes: ['16', '24']
}, {
  name: 'FavoriteFillLight',
  fileName: 'favorite-fill-light',
  sizes: ['16', '24']
}, {
  name: 'FavoriteLine',
  fileName: 'favorite-line',
  sizes: ['16', '24']
}, {
  name: 'FavoriteLineLight',
  fileName: 'favorite-line-light',
  sizes: ['16', '24']
}, {
  name: 'FaxFill',
  fileName: 'fax-fill',
  sizes: ['16', '24']
}, {
  name: 'FaxLine',
  fileName: 'fax-line',
  sizes: ['16', '24']
}, {
  name: 'FigmaFill',
  fileName: 'figma-fill',
  sizes: ['16', '24']
}, {
  name: 'FigmaLine',
  fileName: 'figma-line',
  sizes: ['16', '24']
}, {
  name: 'FilterFill',
  fileName: 'filter-fill',
  sizes: ['16', '24']
}, {
  name: 'FilterLine',
  fileName: 'filter-line',
  sizes: ['16', '24']
}, {
  name: 'FlagFill',
  fileName: 'flag-fill',
  sizes: ['16', '24']
}, {
  name: 'FlagLine',
  fileName: 'flag-line',
  sizes: ['16', '24']
}, {
  name: 'FlashlightAutoFill',
  fileName: 'flashlight-auto-fill',
  sizes: ['16', '24']
}, {
  name: 'FlashlightDisabledFill',
  fileName: 'flashlight-disabled-fill',
  sizes: ['16', '24']
}, {
  name: 'FlashlightEnabledFill',
  fileName: 'flashlight-enabled-fill',
  sizes: ['16', '24']
}, {
  name: 'FlowerFill',
  fileName: 'flower-fill',
  sizes: ['16', '24']
}, {
  name: 'FlowerLine',
  fileName: 'flower-line',
  sizes: ['16', '24']
}, {
  name: 'FoodBowlFill',
  fileName: 'food-bowl-fill',
  sizes: ['16', '24']
}, {
  name: 'FoodBowlLine',
  fileName: 'food-bowl-line',
  sizes: ['16', '24']
}, {
  name: 'FoodLine',
  fileName: 'food-line',
  sizes: ['16', '24']
}, {
  name: 'FuelElectricFill',
  fileName: 'fuel-electric-fill',
  sizes: ['16', '24']
}, {
  name: 'FuelElectricLine',
  fileName: 'fuel-electric-line',
  sizes: ['16', '24']
}, {
  name: 'FuelGasFill',
  fileName: 'fuel-gas-fill',
  sizes: ['16', '24']
}, {
  name: 'FuelGasLine',
  fileName: 'fuel-gas-line',
  sizes: ['16', '24']
}, {
  name: 'FunnelFill',
  fileName: 'funnel-fill',
  sizes: ['16', '24']
}, {
  name: 'FunnelLine',
  fileName: 'funnel-line',
  sizes: ['16', '24']
}, {
  name: 'GiftFill',
  fileName: 'gift-fill',
  sizes: ['16', '24']
}, {
  name: 'GiftLine',
  fileName: 'gift-line',
  sizes: ['16', '24']
}, {
  name: 'GlobeFill',
  fileName: 'globe-fill',
  sizes: ['16', '24']
}, {
  name: 'GlobeLine',
  fileName: 'globe-line',
  sizes: ['16', '24']
}, {
  name: 'GridFill',
  fileName: 'grid-fill',
  sizes: ['16', '24']
}, {
  name: 'GridLine',
  fileName: 'grid-line',
  sizes: ['16', '24']
}, {
  name: 'GroceryLine',
  fileName: 'grocery-line',
  sizes: ['16', '24']
}, {
  name: 'GroupCircles4Fill',
  fileName: 'group-circles-4-fill',
  sizes: ['16', '24']
}, {
  name: 'GroupCircles4Line',
  fileName: 'group-circles-4-line',
  sizes: ['16', '24']
}, {
  name: 'HalfFill',
  fileName: 'half-fill',
  sizes: ['16', '24']
}, {
  name: 'HalfLine',
  fileName: 'half-line',
  sizes: ['16', '24']
}, {
  name: 'HelpCircleFill',
  fileName: 'help-circle-fill',
  sizes: ['16', '24']
}, {
  name: 'HelpCircleLine',
  fileName: 'help-circle-line',
  sizes: ['16', '24']
}, {
  name: 'HelpLifesaver',
  fileName: 'help-lifesaver',
  sizes: ['16', '24']
}, {
  name: 'History',
  fileName: 'history',
  sizes: ['16', '24']
}, {
  name: 'HomeFill',
  fileName: 'home-fill',
  sizes: ['16', '24']
}, {
  name: 'HomeLine',
  fileName: 'home-line',
  sizes: ['16', '24']
}, {
  name: 'IceCreamDrinkFill',
  fileName: 'ice-cream-drink-fill',
  sizes: ['16', '24']
}, {
  name: 'IceCreamDrinkLine',
  fileName: 'ice-cream-drink-line',
  sizes: ['16', '24']
}, {
  name: 'IceCreamFill',
  fileName: 'ice-cream-fill',
  sizes: ['16', '24']
}, {
  name: 'IceCreamLine',
  fileName: 'ice-cream-line',
  sizes: ['16', '24']
}, {
  name: 'InfoCircleFill',
  fileName: 'info-circle-fill',
  sizes: ['16', '24']
}, {
  name: 'InfoCircleLine',
  fileName: 'info-circle-line',
  sizes: ['16', '24']
}, {
  name: 'InfoFill',
  fileName: 'info-fill',
  sizes: ['16', '24']
}, {
  name: 'InfoLine',
  fileName: 'info-line',
  sizes: ['16', '24']
}, {
  name: 'InsightFill',
  fileName: 'insight-fill',
  sizes: ['16', '24']
}, {
  name: 'InsightLine',
  fileName: 'insight-line',
  sizes: ['16', '24']
}, {
  name: 'KeyFill',
  fileName: 'key-fill',
  sizes: ['16', '24']
}, {
  name: 'KeyLine',
  fileName: 'key-line',
  sizes: ['16', '24']
}, {
  name: 'KeyboardFill',
  fileName: 'keyboard-fill',
  sizes: ['16', '24']
}, {
  name: 'KeyboardLine',
  fileName: 'keyboard-line',
  sizes: ['16', '24']
}, {
  name: 'Link',
  fileName: 'link',
  sizes: ['16', '24']
}, {
  name: 'LinkBroken',
  fileName: 'link-broken',
  sizes: ['16', '24']
}, {
  name: 'LinkExternalFill',
  fileName: 'link-external-fill',
  sizes: ['16', '24']
}, {
  name: 'LinkExternalLine',
  fileName: 'link-external-line',
  sizes: ['16', '24']
}, {
  name: 'List',
  fileName: 'list',
  sizes: ['16', '24']
}, {
  name: 'LocationFarFill',
  fileName: 'location-far-fill',
  sizes: ['16', '24']
}, {
  name: 'LocationFarLine',
  fileName: 'location-far-line',
  sizes: ['16', '24']
}, {
  name: 'LocationGpsFill',
  fileName: 'location-gps-fill',
  sizes: ['16', '24']
}, {
  name: 'LocationGpsLine',
  fileName: 'location-gps-line',
  sizes: ['16', '24']
}, {
  name: 'LocationNearFill',
  fileName: 'location-near-fill',
  sizes: ['16', '24']
}, {
  name: 'LocationNearLine',
  fileName: 'location-near-line',
  sizes: ['16', '24']
}, {
  name: 'LocationPinDisabledFill',
  fileName: 'location-pin-disabled-fill',
  sizes: ['16', '24']
}, {
  name: 'LocationPinDisabledLine',
  fileName: 'location-pin-disabled-line',
  sizes: ['16', '24']
}, {
  name: 'LocationPinEnabledFill',
  fileName: 'location-pin-enabled-fill',
  sizes: ['16', '24']
}, {
  name: 'LocationPinEnabledLine',
  fileName: 'location-pin-enabled-line',
  sizes: ['16', '24']
}, {
  name: 'LocationPointerFill',
  fileName: 'location-pointer-fill',
  sizes: ['16', '24']
}, {
  name: 'LocationPointerLine',
  fileName: 'location-pointer-line',
  sizes: ['16', '24']
}, {
  name: 'LockedFill',
  fileName: 'locked-fill',
  sizes: ['16', '24']
}, {
  name: 'LockedLine',
  fileName: 'locked-line',
  sizes: ['16', '24']
}, {
  name: 'LogoAdtColor',
  fileName: 'logo-adt-color',
  sizes: ['16', '24']
}, {
  name: 'LogoAdtMonocolor',
  fileName: 'logo-adt-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoAfterpay',
  fileName: 'logo-afterpay',
  sizes: ['16', '24']
}, {
  name: 'LogoAfterpayColor',
  fileName: 'logo-afterpay-color',
  sizes: ['16', '24']
}, {
  name: 'LogoAfterpayMonocolor',
  fileName: 'logo-afterpay-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoAndroid',
  fileName: 'logo-android',
  sizes: ['16', '24']
}, {
  name: 'LogoApple',
  fileName: 'logo-apple',
  sizes: ['16', '24']
}, {
  name: 'LogoCashappColor',
  fileName: 'logo-cashapp-color',
  sizes: ['16', '24']
}, {
  name: 'LogoCashappMonocolor',
  fileName: 'logo-cashapp-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoChase',
  fileName: 'logo-chase',
  sizes: ['16', '24']
}, {
  name: 'LogoCheckrColor',
  fileName: 'logo-checkr-color',
  sizes: ['16', '24']
}, {
  name: 'LogoCheckrMonocolor',
  fileName: 'logo-checkr-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoConcurColor',
  fileName: 'logo-concur-color',
  sizes: ['16', '24']
}, {
  name: 'LogoConcurMonocolor',
  fileName: 'logo-concur-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoCourierColor',
  fileName: 'logo-courier-color',
  sizes: ['16', '24']
}, {
  name: 'LogoCourierMonocolor',
  fileName: 'logo-courier-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoDasherColor',
  fileName: 'logo-dasher-color',
  sizes: ['16', '24']
}, {
  name: 'LogoDasherMonocolor',
  fileName: 'logo-dasher-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoDashpass',
  fileName: 'logo-dashpass',
  sizes: ['16', '24']
}, {
  name: 'LogoDashpassMonocolor',
  fileName: 'logo-dashpass-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoDashpassNew',
  fileName: 'logo-dashpass-new',
  sizes: ['16', '24']
}, {
  name: 'LogoDoordash',
  fileName: 'logo-doordash',
  sizes: ['16', '24']
}, {
  name: 'LogoFacebook',
  fileName: 'logo-facebook',
  sizes: ['16', '24']
}, {
  name: 'LogoGithubColor',
  fileName: 'logo-github-color',
  sizes: ['16', '24']
}, {
  name: 'LogoGithubMonocolor',
  fileName: 'logo-github-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoGlassdoor',
  fileName: 'logo-glassdoor',
  sizes: ['16', '24']
}, {
  name: 'LogoGoogle',
  fileName: 'logo-google',
  sizes: ['16', '24']
}, {
  name: 'LogoGoogleMapsColor',
  fileName: 'logo-google-maps-color',
  sizes: ['16', '24']
}, {
  name: 'LogoGoogleMapsMonocolor',
  fileName: 'logo-google-maps-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoInstagram',
  fileName: 'logo-instagram',
  sizes: ['16', '24']
}, {
  name: 'LogoLineColor',
  fileName: 'logo-line-color',
  sizes: ['16', '24']
}, {
  name: 'LogoLineMonocolor',
  fileName: 'logo-line-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoLinkedin',
  fileName: 'logo-linkedin',
  sizes: ['16', '24']
}, {
  name: 'LogoMedium',
  fileName: 'logo-medium',
  sizes: ['16', '24']
}, {
  name: 'LogoMerchantColor',
  fileName: 'logo-merchant-color',
  sizes: ['16', '24']
}, {
  name: 'LogoMerchantMonocolor',
  fileName: 'logo-merchant-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoPaypayColor',
  fileName: 'logo-paypay-color',
  sizes: ['16', '24']
}, {
  name: 'LogoPaypayMonocolor',
  fileName: 'logo-paypay-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoPersonaColor',
  fileName: 'logo-persona-color',
  sizes: ['16', '24']
}, {
  name: 'LogoPersonaMonocolor',
  fileName: 'logo-persona-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoSalesforceColor',
  fileName: 'logo-salesforce-color',
  sizes: ['16', '24']
}, {
  name: 'LogoSalesforceMonocolor',
  fileName: 'logo-salesforce-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoSiftColor',
  fileName: 'logo-sift-color',
  sizes: ['16', '24']
}, {
  name: 'LogoSiftMonocolor',
  fileName: 'logo-sift-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoSnapEbtColor',
  fileName: 'logo-snap-ebt-color',
  sizes: ['16', '24']
}, {
  name: 'LogoSnapEbtMonocolor',
  fileName: 'logo-snap-ebt-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoSquare',
  fileName: 'logo-square',
  sizes: ['16', '24']
}, {
  name: 'LogoStripeColor',
  fileName: 'logo-stripe-color',
  sizes: ['16', '24']
}, {
  name: 'LogoStripeMonocolor',
  fileName: 'logo-stripe-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoToastColor',
  fileName: 'logo-toast-color',
  sizes: ['16', '24']
}, {
  name: 'LogoToastMonocolor',
  fileName: 'logo-toast-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoTwitter',
  fileName: 'logo-twitter',
  sizes: ['16', '24']
}, {
  name: 'LogoVenmo',
  fileName: 'logo-venmo',
  sizes: ['16', '24']
}, {
  name: 'LogoWazeColor',
  fileName: 'logo-waze-color',
  sizes: ['16', '24']
}, {
  name: 'LogoWazeMonocolor',
  fileName: 'logo-waze-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoWebhooks',
  fileName: 'logo-webhooks',
  sizes: ['16', '24']
}, {
  name: 'LogoWhatsappColor',
  fileName: 'logo-whatsapp-color',
  sizes: ['16', '24']
}, {
  name: 'LogoWhatsappMonocolor',
  fileName: 'logo-whatsapp-monocolor',
  sizes: ['16', '24']
}, {
  name: 'LogoutFill',
  fileName: 'logout-fill',
  sizes: ['16', '24']
}, {
  name: 'LogoutLine',
  fileName: 'logout-line',
  sizes: ['16', '24']
}, {
  name: 'LoyaltyLine',
  fileName: 'loyalty-line',
  sizes: ['16', '24']
}, {
  name: 'MapFill',
  fileName: 'map-fill',
  sizes: ['16', '24']
}, {
  name: 'MapLine',
  fileName: 'map-line',
  sizes: ['16', '24']
}, {
  name: 'MapPinLine',
  fileName: 'map-pin-line',
  sizes: ['16', '24']
}, {
  name: 'MaskFill',
  fileName: 'mask-fill',
  sizes: ['16', '24']
}, {
  name: 'MaskLine',
  fileName: 'mask-line',
  sizes: ['16', '24']
}, {
  name: 'Menu',
  fileName: 'menu',
  sizes: ['16', '24']
}, {
  name: 'MenuEditFill',
  fileName: 'menu-edit-fill',
  sizes: ['16', '24']
}, {
  name: 'MenuEditLine',
  fileName: 'menu-edit-line',
  sizes: ['16', '24']
}, {
  name: 'MenuShare',
  fileName: 'menu-share',
  sizes: ['16', '24']
}, {
  name: 'MerchantDisabledFill',
  fileName: 'merchant-disabled-fill',
  sizes: ['16', '24']
}, {
  name: 'MerchantDisabledLine',
  fileName: 'merchant-disabled-line',
  sizes: ['16', '24']
}, {
  name: 'MerchantFill',
  fileName: 'merchant-fill',
  sizes: ['16', '24']
}, {
  name: 'MerchantLine',
  fileName: 'merchant-line',
  sizes: ['16', '24']
}, {
  name: 'MicrophoneFill',
  fileName: 'microphone-fill',
  sizes: ['16', '24']
}, {
  name: 'MicrophoneLine',
  fileName: 'microphone-line',
  sizes: ['16', '24']
}, {
  name: 'MiscellaneousFill',
  fileName: 'miscellaneous-fill',
  sizes: ['16', '24']
}, {
  name: 'MiscellaneousLine',
  fileName: 'miscellaneous-line',
  sizes: ['16', '24']
}, {
  name: 'MoneyBank',
  fileName: 'money-bank',
  sizes: ['16', '24']
}, {
  name: 'MoneyCircleDisabledFill',
  fileName: 'money-circle-disabled-fill',
  sizes: ['16', '24']
}, {
  name: 'MoneyCircleDisabledLine',
  fileName: 'money-circle-disabled-line',
  sizes: ['16', '24']
}, {
  name: 'MoneyCircleEnabledFill',
  fileName: 'money-circle-enabled-fill',
  sizes: ['16', '24']
}, {
  name: 'MoneyCircleEnabledLine',
  fileName: 'money-circle-enabled-line',
  sizes: ['16', '24']
}, {
  name: 'MoneyCircleFill',
  fileName: 'money-circle-fill',
  sizes: ['16', '24']
}, {
  name: 'MoneyCircleLine',
  fileName: 'money-circle-line',
  sizes: ['16', '24']
}, {
  name: 'MoneyDefault',
  fileName: 'money-default',
  sizes: ['16', '24']
}, {
  name: 'MoneyEuro',
  fileName: 'money-euro',
  sizes: ['16', '24']
}, {
  name: 'MoneyEuroCircleDisabledFill',
  fileName: 'money-euro-circle-disabled-fill',
  sizes: ['16', '24']
}, {
  name: 'MoneyEuroCircleDisabledLine',
  fileName: 'money-euro-circle-disabled-line',
  sizes: ['16', '24']
}, {
  name: 'MoneyEuroCircleEnabledFill',
  fileName: 'money-euro-circle-enabled-fill',
  sizes: ['16', '24']
}, {
  name: 'MoneyEuroCircleEnabledLine',
  fileName: 'money-euro-circle-enabled-line',
  sizes: ['16', '24']
}, {
  name: 'MoneyYen',
  fileName: 'money-yen',
  sizes: ['16', '24']
}, {
  name: 'MoneyYenCircleDisabledFill',
  fileName: 'money-yen-circle-disabled-fill',
  sizes: ['16', '24']
}, {
  name: 'MoneyYenCircleDisabledLine',
  fileName: 'money-yen-circle-disabled-line',
  sizes: ['16', '24']
}, {
  name: 'MoneyYenCircleEnabledFill',
  fileName: 'money-yen-circle-enabled-fill',
  sizes: ['16', '24']
}, {
  name: 'MoneyYenCircleEnabledLine',
  fileName: 'money-yen-circle-enabled-line',
  sizes: ['16', '24']
}, {
  name: 'MoreHorizontal',
  fileName: 'more-horizontal',
  sizes: ['16', '24']
}, {
  name: 'MoreVertical',
  fileName: 'more-vertical',
  sizes: ['16', '24']
}, {
  name: 'NotesFill',
  fileName: 'notes-fill',
  sizes: ['16', '24']
}, {
  name: 'NotesLine',
  fileName: 'notes-line',
  sizes: ['16', '24']
}, {
  name: 'NotifyFill',
  fileName: 'notify-fill',
  sizes: ['16', '24']
}, {
  name: 'NotifyLine',
  fileName: 'notify-line',
  sizes: ['16', '24']
}, {
  name: 'Number1Fill',
  fileName: 'number-1-fill',
  sizes: ['16', '24']
}, {
  name: 'Number1Line',
  fileName: 'number-1-line',
  sizes: ['16', '24']
}, {
  name: 'Number2Fill',
  fileName: 'number-2-fill',
  sizes: ['16', '24']
}, {
  name: 'Number2Line',
  fileName: 'number-2-line',
  sizes: ['16', '24']
}, {
  name: 'Number3Fill',
  fileName: 'number-3-fill',
  sizes: ['16', '24']
}, {
  name: 'Number3Line',
  fileName: 'number-3-line',
  sizes: ['16', '24']
}, {
  name: 'Number4Fill',
  fileName: 'number-4-fill',
  sizes: ['16', '24']
}, {
  name: 'Number4Line',
  fileName: 'number-4-line',
  sizes: ['16', '24']
}, {
  name: 'Number5Fill',
  fileName: 'number-5-fill',
  sizes: ['16', '24']
}, {
  name: 'Number5Line',
  fileName: 'number-5-line',
  sizes: ['16', '24']
}, {
  name: 'Number6Fill',
  fileName: 'number-6-fill',
  sizes: ['16', '24']
}, {
  name: 'Number6Line',
  fileName: 'number-6-line',
  sizes: ['16', '24']
}, {
  name: 'Number7Fill',
  fileName: 'number-7-fill',
  sizes: ['16', '24']
}, {
  name: 'Number7Line',
  fileName: 'number-7-line',
  sizes: ['16', '24']
}, {
  name: 'Number8Fill',
  fileName: 'number-8-fill',
  sizes: ['16', '24']
}, {
  name: 'Number8Line',
  fileName: 'number-8-line',
  sizes: ['16', '24']
}, {
  name: 'Number9Fill',
  fileName: 'number-9-fill',
  sizes: ['16', '24']
}, {
  name: 'Number9Line',
  fileName: 'number-9-line',
  sizes: ['16', '24']
}, {
  name: 'Office',
  fileName: 'office',
  sizes: ['16', '24']
}, {
  name: 'OrderBagFill',
  fileName: 'order-bag-fill',
  sizes: ['16', '24']
}, {
  name: 'OrderBagLine',
  fileName: 'order-bag-line',
  sizes: ['16', '24']
}, {
  name: 'OrderBatchFill',
  fileName: 'order-batch-fill',
  sizes: ['16', '24']
}, {
  name: 'OrderBatchLine',
  fileName: 'order-batch-line',
  sizes: ['16', '24']
}, {
  name: 'OrderHotbagFill',
  fileName: 'order-hotbag-fill',
  sizes: ['16', '24']
}, {
  name: 'OrderHotbagLine',
  fileName: 'order-hotbag-line',
  sizes: ['16', '24']
}, {
  name: 'OrderIncorrectFill',
  fileName: 'order-incorrect-fill',
  sizes: ['16', '24']
}, {
  name: 'OrderIncorrectLine',
  fileName: 'order-incorrect-line',
  sizes: ['16', '24']
}, {
  name: 'OrderLargeFill',
  fileName: 'order-large-fill',
  sizes: ['16', '24']
}, {
  name: 'OrderLargeFillFrCa',
  fileName: 'order-large-fill-fr-ca',
  sizes: ['16', '24']
}, {
  name: 'OrderLargeLine',
  fileName: 'order-large-line',
  sizes: ['16', '24']
}, {
  name: 'OrderLargeLineFrCa',
  fileName: 'order-large-line-fr-ca',
  sizes: ['16', '24']
}, {
  name: 'OrderMediumFill',
  fileName: 'order-medium-fill',
  sizes: ['16', '24']
}, {
  name: 'OrderMediumFillFrCa',
  fileName: 'order-medium-fill-fr-ca',
  sizes: ['16', '24']
}, {
  name: 'OrderMediumLine',
  fileName: 'order-medium-line',
  sizes: ['16', '24']
}, {
  name: 'OrderMediumLineFrCa',
  fileName: 'order-medium-line-fr-ca',
  sizes: ['16', '24']
}, {
  name: 'OrderProtocol',
  fileName: 'order-protocol',
  sizes: ['16', '24']
}, {
  name: 'OrderSmallFill',
  fileName: 'order-small-fill',
  sizes: ['16', '24']
}, {
  name: 'OrderSmallFillFrCa',
  fileName: 'order-small-fill-fr-ca',
  sizes: ['16', '24']
}, {
  name: 'OrderSmallLine',
  fileName: 'order-small-line',
  sizes: ['16', '24']
}, {
  name: 'OrderSmallLineFrCa',
  fileName: 'order-small-line-fr-ca',
  sizes: ['16', '24']
}, {
  name: 'PalmTree',
  fileName: 'palm-tree',
  sizes: ['16', '24']
}, {
  name: 'ParkingEsMxFill',
  fileName: 'parking-es-mx-fill',
  sizes: ['16', '24']
}, {
  name: 'ParkingEsMxLine',
  fileName: 'parking-es-mx-line',
  sizes: ['16', '24']
}, {
  name: 'ParkingFill',
  fileName: 'parking-fill',
  sizes: ['16', '24']
}, {
  name: 'ParkingLine',
  fileName: 'parking-line',
  sizes: ['16', '24']
}, {
  name: 'PauseFill',
  fileName: 'pause-fill',
  sizes: ['16', '24']
}, {
  name: 'PauseLine',
  fileName: 'pause-line',
  sizes: ['16', '24']
}, {
  name: 'PaymentFill',
  fileName: 'payment-fill',
  sizes: ['16', '24']
}, {
  name: 'PaymentLine',
  fileName: 'payment-line',
  sizes: ['16', '24']
}, {
  name: 'PeopleAddFill',
  fileName: 'people-add-fill',
  sizes: ['16', '24']
}, {
  name: 'PeopleAddLine',
  fileName: 'people-add-line',
  sizes: ['16', '24']
}, {
  name: 'PeopleGroupFill',
  fileName: 'people-group-fill',
  sizes: ['16', '24']
}, {
  name: 'PeopleGroupLine',
  fileName: 'people-group-line',
  sizes: ['16', '24']
}, {
  name: 'PersonFindFill',
  fileName: 'person-find-fill',
  sizes: ['16', '24']
}, {
  name: 'PersonFindLine',
  fileName: 'person-find-line',
  sizes: ['16', '24']
}, {
  name: 'PersonProfileFill',
  fileName: 'person-profile-fill',
  sizes: ['16', '24']
}, {
  name: 'PersonProfileLine',
  fileName: 'person-profile-line',
  sizes: ['16', '24']
}, {
  name: 'PersonUserFill',
  fileName: 'person-user-fill',
  sizes: ['16', '24']
}, {
  name: 'PersonUserLine',
  fileName: 'person-user-line',
  sizes: ['16', '24']
}, {
  name: 'PetsFill',
  fileName: 'pets-fill',
  sizes: ['16', '24']
}, {
  name: 'PetsLine',
  fileName: 'pets-line',
  sizes: ['16', '24']
}, {
  name: 'PharmacyFill',
  fileName: 'pharmacy-fill',
  sizes: ['16', '24']
}, {
  name: 'PharmacyLine',
  fileName: 'pharmacy-line',
  sizes: ['16', '24']
}, {
  name: 'PhoneCallFill',
  fileName: 'phone-call-fill',
  sizes: ['16', '24']
}, {
  name: 'PhoneCallLine',
  fileName: 'phone-call-line',
  sizes: ['16', '24']
}, {
  name: 'PhotoFill',
  fileName: 'photo-fill',
  sizes: ['16', '24']
}, {
  name: 'PhotoFlipFill',
  fileName: 'photo-flip-fill',
  sizes: ['16', '24']
}, {
  name: 'PhotoFlipLine',
  fileName: 'photo-flip-line',
  sizes: ['16', '24']
}, {
  name: 'PhotoLine',
  fileName: 'photo-line',
  sizes: ['16', '24']
}, {
  name: 'PhotoRotateFill',
  fileName: 'photo-rotate-fill',
  sizes: ['16', '24']
}, {
  name: 'PhotoRotateLine',
  fileName: 'photo-rotate-line',
  sizes: ['16', '24']
}, {
  name: 'PhotoUploadFill',
  fileName: 'photo-upload-fill',
  sizes: ['16', '24']
}, {
  name: 'PhotoUploadLine',
  fileName: 'photo-upload-line',
  sizes: ['16', '24']
}, {
  name: 'PhotosFill',
  fileName: 'photos-fill',
  sizes: ['16', '24']
}, {
  name: 'PhotosLine',
  fileName: 'photos-line',
  sizes: ['16', '24']
}, {
  name: 'PizzaFill',
  fileName: 'pizza-fill',
  sizes: ['16', '24']
}, {
  name: 'PizzaLine',
  fileName: 'pizza-line',
  sizes: ['16', '24']
}, {
  name: 'Plate',
  fileName: 'plate',
  sizes: ['16', '24']
}, {
  name: 'PlayFill',
  fileName: 'play-fill',
  sizes: ['16', '24']
}, {
  name: 'PlayLine',
  fileName: 'play-line',
  sizes: ['16', '24']
}, {
  name: 'PluginFill',
  fileName: 'plugin-fill',
  sizes: ['16', '24']
}, {
  name: 'PluginLine',
  fileName: 'plugin-line',
  sizes: ['16', '24']
}, {
  name: 'PrintFill',
  fileName: 'print-fill',
  sizes: ['16', '24']
}, {
  name: 'PrintLine',
  fileName: 'print-line',
  sizes: ['16', '24']
}, {
  name: 'PrismFill',
  fileName: 'prism-fill',
  sizes: ['16', '24']
}, {
  name: 'PrismLine',
  fileName: 'prism-line',
  sizes: ['16', '24']
}, {
  name: 'ProhibitedFill',
  fileName: 'prohibited-fill',
  sizes: ['16', '24']
}, {
  name: 'ProhibitedLine',
  fileName: 'prohibited-line',
  sizes: ['16', '24']
}, {
  name: 'PromoBullhornFill',
  fileName: 'promo-bullhorn-fill',
  sizes: ['16', '24']
}, {
  name: 'PromoBullhornLine',
  fileName: 'promo-bullhorn-line',
  sizes: ['16', '24']
}, {
  name: 'PromoFill',
  fileName: 'promo-fill',
  sizes: ['16', '24']
}, {
  name: 'PromoLine',
  fileName: 'promo-line',
  sizes: ['16', '24']
}, {
  name: 'RackFill',
  fileName: 'rack-fill',
  sizes: ['16', '24']
}, {
  name: 'RackLine',
  fileName: 'rack-line',
  sizes: ['16', '24']
}, {
  name: 'RadioOffCircleLine',
  fileName: 'radio-off-circle-line',
  sizes: ['16', '24']
}, {
  name: 'RadioOnCircleFill',
  fileName: 'radio-on-circle-fill',
  sizes: ['16', '24']
}, {
  name: 'RearrangeVertical',
  fileName: 'rearrange-vertical',
  sizes: ['16', '24']
}, {
  name: 'ReceiptCancelOrderFill',
  fileName: 'receipt-cancel-order-fill',
  sizes: ['16', '24']
}, {
  name: 'ReceiptCancelOrderLine',
  fileName: 'receipt-cancel-order-line',
  sizes: ['16', '24']
}, {
  name: 'ReceiptFill',
  fileName: 'receipt-fill',
  sizes: ['16', '24']
}, {
  name: 'ReceiptLine',
  fileName: 'receipt-line',
  sizes: ['16', '24']
}, {
  name: 'RefundFill',
  fileName: 'refund-fill',
  sizes: ['16', '24']
}, {
  name: 'RefundLine',
  fileName: 'refund-line',
  sizes: ['16', '24']
}, {
  name: 'RetailLine',
  fileName: 'retail-line',
  sizes: ['16', '24']
}, {
  name: 'RewardFill',
  fileName: 'reward-fill',
  sizes: ['16', '24']
}, {
  name: 'RewardLine',
  fileName: 'reward-line',
  sizes: ['16', '24']
}, {
  name: 'RobotFill',
  fileName: 'robot-fill',
  sizes: ['16', '24']
}, {
  name: 'RobotLine',
  fileName: 'robot-line',
  sizes: ['16', '24']
}, {
  name: 'Rotate',
  fileName: 'rotate',
  sizes: ['16', '24']
}, {
  name: 'RunTest',
  fileName: 'run-test',
  sizes: ['16', '24']
}, {
  name: 'RunTestFill',
  fileName: 'run-test-fill',
  sizes: ['16', '24']
}, {
  name: 'SafetyFill',
  fileName: 'safety-fill',
  sizes: ['16', '24']
}, {
  name: 'SafetyLine',
  fileName: 'safety-line',
  sizes: ['16', '24']
}, {
  name: 'SatelliteFill',
  fileName: 'satellite-fill',
  sizes: ['16', '24']
}, {
  name: 'SatelliteLine',
  fileName: 'satellite-line',
  sizes: ['16', '24']
}, {
  name: 'Scale',
  fileName: 'scale',
  sizes: ['16', '24']
}, {
  name: 'Scan',
  fileName: 'scan',
  sizes: ['16', '24']
}, {
  name: 'Search',
  fileName: 'search',
  sizes: ['16', '24']
}, {
  name: 'SearchFill',
  fileName: 'search-fill',
  sizes: ['16', '24']
}, {
  name: 'SearchLine',
  fileName: 'search-line',
  sizes: ['16', '24']
}, {
  name: 'Send',
  fileName: 'send',
  sizes: ['16', '24']
}, {
  name: 'SendFill',
  fileName: 'send-fill',
  sizes: ['16', '24']
}, {
  name: 'SendLine',
  fileName: 'send-line',
  sizes: ['16', '24']
}, {
  name: 'SettingsFill',
  fileName: 'settings-fill',
  sizes: ['16', '24']
}, {
  name: 'SettingsLine',
  fileName: 'settings-line',
  sizes: ['16', '24']
}, {
  name: 'ShareFill',
  fileName: 'share-fill',
  sizes: ['16', '24']
}, {
  name: 'ShareLine',
  fileName: 'share-line',
  sizes: ['16', '24']
}, {
  name: 'ShelfFill',
  fileName: 'shelf-fill',
  sizes: ['16', '24']
}, {
  name: 'ShelfLine',
  fileName: 'shelf-line',
  sizes: ['16', '24']
}, {
  name: 'ShieldCheckFill',
  fileName: 'shield-check-fill',
  sizes: ['16', '24']
}, {
  name: 'ShieldCheckLine',
  fileName: 'shield-check-line',
  sizes: ['16', '24']
}, {
  name: 'SignalHigh',
  fileName: 'signal-high',
  sizes: ['16', '24']
}, {
  name: 'SignalLow',
  fileName: 'signal-low',
  sizes: ['16', '24']
}, {
  name: 'SignalMedium',
  fileName: 'signal-medium',
  sizes: ['16', '24']
}, {
  name: 'SkewHorizontalFill',
  fileName: 'skew-horizontal-fill',
  sizes: ['16', '24']
}, {
  name: 'SkewHorizontalLine',
  fileName: 'skew-horizontal-line',
  sizes: ['16', '24']
}, {
  name: 'SkewVerticalFill',
  fileName: 'skew-vertical-fill',
  sizes: ['16', '24']
}, {
  name: 'SkewVerticalLine',
  fileName: 'skew-vertical-line',
  sizes: ['16', '24']
}, {
  name: 'SmileyHappyFill',
  fileName: 'smiley-happy-fill',
  sizes: ['16', '24']
}, {
  name: 'SmileyHappyLine',
  fileName: 'smiley-happy-line',
  sizes: ['16', '24']
}, {
  name: 'SmileyNeutralFill',
  fileName: 'smiley-neutral-fill',
  sizes: ['16', '24']
}, {
  name: 'SmileyNeutralLine',
  fileName: 'smiley-neutral-line',
  sizes: ['16', '24']
}, {
  name: 'SmileySadFill',
  fileName: 'smiley-sad-fill',
  sizes: ['16', '24']
}, {
  name: 'SmileySadLine',
  fileName: 'smiley-sad-line',
  sizes: ['16', '24']
}, {
  name: 'Sort',
  fileName: 'sort',
  sizes: ['16', '24']
}, {
  name: 'SortOrder',
  fileName: 'sort-order',
  sizes: ['16', '24']
}, {
  name: 'Sos',
  fileName: 'sos',
  sizes: ['16', '24']
}, {
  name: 'SpellingFill',
  fileName: 'spelling-fill',
  sizes: ['16', '24']
}, {
  name: 'SpellingLine',
  fileName: 'spelling-line',
  sizes: ['16', '24']
}, {
  name: 'StarFill',
  fileName: 'star-fill',
  sizes: ['16', '24']
}, {
  name: 'StarHalf',
  fileName: 'star-half',
  sizes: ['16', '24']
}, {
  name: 'StarLine',
  fileName: 'star-line',
  sizes: ['16', '24']
}, {
  name: 'StatusDotClosedColor',
  fileName: 'status-dot-closed-color',
  sizes: ['16', '24']
}, {
  name: 'StatusDotClosedMonocolor',
  fileName: 'status-dot-closed-monocolor',
  sizes: ['16', '24']
}, {
  name: 'StatusDotDeactivatedColor',
  fileName: 'status-dot-deactivated-color',
  sizes: ['16', '24']
}, {
  name: 'StatusDotDeactivatedMonocolor',
  fileName: 'status-dot-deactivated-monocolor',
  sizes: ['16', '24']
}, {
  name: 'StatusDotDriveColor',
  fileName: 'status-dot-drive-color',
  sizes: ['16', '24']
}, {
  name: 'StatusDotDriveMonocolor',
  fileName: 'status-dot-drive-monocolor',
  sizes: ['16', '24']
}, {
  name: 'StatusDotInactiveColor',
  fileName: 'status-dot-inactive-color',
  sizes: ['16', '24']
}, {
  name: 'StatusDotInactiveMonocolor',
  fileName: 'status-dot-inactive-monocolor',
  sizes: ['16', '24']
}, {
  name: 'StatusDotOpenColor',
  fileName: 'status-dot-open-color',
  sizes: ['16', '24']
}, {
  name: 'StatusDotOpenMonocolor',
  fileName: 'status-dot-open-monocolor',
  sizes: ['16', '24']
}, {
  name: 'StatusDotPausedColor',
  fileName: 'status-dot-paused-color',
  sizes: ['16', '24']
}, {
  name: 'StatusDotPausedMonocolor',
  fileName: 'status-dot-paused-monocolor',
  sizes: ['16', '24']
}, {
  name: 'Subtract',
  fileName: 'subtract',
  sizes: ['16', '24']
}, {
  name: 'SubtractCircleFill',
  fileName: 'subtract-circle-fill',
  sizes: ['16', '24']
}, {
  name: 'SubtractCircleLine',
  fileName: 'subtract-circle-line',
  sizes: ['16', '24']
}, {
  name: 'SubtractSquareFill',
  fileName: 'subtract-square-fill',
  sizes: ['16', '24']
}, {
  name: 'SubtractSquareLine',
  fileName: 'subtract-square-line',
  sizes: ['16', '24']
}, {
  name: 'Swap',
  fileName: 'swap',
  sizes: ['16', '24']
}, {
  name: 'SwapCircleFill',
  fileName: 'swap-circle-fill',
  sizes: ['16', '24']
}, {
  name: 'SwapCircleLine',
  fileName: 'swap-circle-line',
  sizes: ['16', '24']
}, {
  name: 'Sync',
  fileName: 'sync',
  sizes: ['16', '24']
}, {
  name: 'Table',
  fileName: 'table',
  sizes: ['16', '24']
}, {
  name: 'ThumbsDownFill',
  fileName: 'thumbs-down-fill',
  sizes: ['16', '24']
}, {
  name: 'ThumbsDownLine',
  fileName: 'thumbs-down-line',
  sizes: ['16', '24']
}, {
  name: 'ThumbsUpFill',
  fileName: 'thumbs-up-fill',
  sizes: ['16', '24']
}, {
  name: 'ThumbsUpLine',
  fileName: 'thumbs-up-line',
  sizes: ['16', '24']
}, {
  name: 'TimeFill',
  fileName: 'time-fill',
  sizes: ['16', '24']
}, {
  name: 'TimeLine',
  fileName: 'time-line',
  sizes: ['16', '24']
}, {
  name: 'TippingFill',
  fileName: 'tipping-fill',
  sizes: ['16', '24']
}, {
  name: 'TippingLine',
  fileName: 'tipping-line',
  sizes: ['16', '24']
}, {
  name: 'TipsStaffFill',
  fileName: 'tips-staff-fill',
  sizes: ['16', '24']
}, {
  name: 'TipsStaffLine',
  fileName: 'tips-staff-line',
  sizes: ['16', '24']
}, {
  name: 'ToiletFill',
  fileName: 'toilet-fill',
  sizes: ['16', '24']
}, {
  name: 'ToiletLine',
  fileName: 'toilet-line',
  sizes: ['16', '24']
}, {
  name: 'ToteBarcodeFill',
  fileName: 'tote-barcode-fill',
  sizes: ['16', '24']
}, {
  name: 'ToteBarcodeLine',
  fileName: 'tote-barcode-line',
  sizes: ['16', '24']
}, {
  name: 'ToteFill',
  fileName: 'tote-fill',
  sizes: ['16', '24']
}, {
  name: 'ToteLine',
  fileName: 'tote-line',
  sizes: ['16', '24']
}, {
  name: 'TrashFill',
  fileName: 'trash-fill',
  sizes: ['16', '24']
}, {
  name: 'TrashLine',
  fileName: 'trash-line',
  sizes: ['16', '24']
}, {
  name: 'TrashRestoreFill',
  fileName: 'trash-restore-fill',
  sizes: ['16', '24']
}, {
  name: 'TrashRestoreLine',
  fileName: 'trash-restore-line',
  sizes: ['16', '24']
}, {
  name: 'TrendDownCaret',
  fileName: 'trend-down-caret',
  sizes: ['16', '24']
}, {
  name: 'TrendUpCaret',
  fileName: 'trend-up-caret',
  sizes: ['16', '24']
}, {
  name: 'TrophyFill',
  fileName: 'trophy-fill',
  sizes: ['16', '24']
}, {
  name: 'TrophyLine',
  fileName: 'trophy-line',
  sizes: ['16', '24']
}, {
  name: 'UnlockedFill',
  fileName: 'unlocked-fill',
  sizes: ['16', '24']
}, {
  name: 'UnlockedLine',
  fileName: 'unlocked-line',
  sizes: ['16', '24']
}, {
  name: 'UploadFill',
  fileName: 'upload-fill',
  sizes: ['16', '24']
}, {
  name: 'UploadLine',
  fileName: 'upload-line',
  sizes: ['16', '24']
}, {
  name: 'VehicleAirplane',
  fileName: 'vehicle-airplane',
  sizes: ['16', '24']
}, {
  name: 'VehicleBikeFill',
  fileName: 'vehicle-bike-fill',
  sizes: ['16', '24']
}, {
  name: 'VehicleBikeLine',
  fileName: 'vehicle-bike-line',
  sizes: ['16', '24']
}, {
  name: 'VehicleCar',
  fileName: 'vehicle-car',
  sizes: ['16', '24']
}, {
  name: 'VehicleEbikeFill',
  fileName: 'vehicle-ebike-fill',
  sizes: ['16', '24']
}, {
  name: 'VehicleEbikeLine',
  fileName: 'vehicle-ebike-line',
  sizes: ['16', '24']
}, {
  name: 'VehicleMotorcycleFill',
  fileName: 'vehicle-motorcycle-fill',
  sizes: ['16', '24']
}, {
  name: 'VehicleMotorcycleLine',
  fileName: 'vehicle-motorcycle-line',
  sizes: ['16', '24']
}, {
  name: 'VehicleScooterFill',
  fileName: 'vehicle-scooter-fill',
  sizes: ['16', '24']
}, {
  name: 'VehicleScooterLine',
  fileName: 'vehicle-scooter-line',
  sizes: ['16', '24']
}, {
  name: 'VehicleWalk',
  fileName: 'vehicle-walk',
  sizes: ['16', '24']
}, {
  name: 'VideoFill',
  fileName: 'video-fill',
  sizes: ['16', '24']
}, {
  name: 'VideoLine',
  fileName: 'video-line',
  sizes: ['16', '24']
}, {
  name: 'ViewCollapse',
  fileName: 'view-collapse',
  sizes: ['16', '24']
}, {
  name: 'ViewExpand',
  fileName: 'view-expand',
  sizes: ['16', '24']
}, {
  name: 'VolumeHighFill',
  fileName: 'volume-high-fill',
  sizes: ['16', '24']
}, {
  name: 'VolumeHighLine',
  fileName: 'volume-high-line',
  sizes: ['16', '24']
}, {
  name: 'VolumeLowFill',
  fileName: 'volume-low-fill',
  sizes: ['16', '24']
}, {
  name: 'VolumeLowLine',
  fileName: 'volume-low-line',
  sizes: ['16', '24']
}, {
  name: 'VolumeMuteFill',
  fileName: 'volume-mute-fill',
  sizes: ['16', '24']
}, {
  name: 'VolumeMuteLine',
  fileName: 'volume-mute-line',
  sizes: ['16', '24']
}, {
  name: 'VolumeNoneFill',
  fileName: 'volume-none-fill',
  sizes: ['16', '24']
}, {
  name: 'VolumeNoneLine',
  fileName: 'volume-none-line',
  sizes: ['16', '24']
}, {
  name: 'WarningCircleFill',
  fileName: 'warning-circle-fill',
  sizes: ['16', '24']
}, {
  name: 'WarningCircleLine',
  fileName: 'warning-circle-line',
  sizes: ['16', '24']
}, {
  name: 'WarningFill',
  fileName: 'warning-fill',
  sizes: ['16', '24']
}, {
  name: 'WarningLine',
  fileName: 'warning-line',
  sizes: ['16', '24']
}, {
  name: 'WarningTriangleFill',
  fileName: 'warning-triangle-fill',
  sizes: ['16', '24']
}, {
  name: 'WarningTriangleLine',
  fileName: 'warning-triangle-line',
  sizes: ['16', '24']
}, {
  name: 'Wifi0Line',
  fileName: 'wifi-0-line',
  sizes: ['16', '24']
}, {
  name: 'Wifi1Line',
  fileName: 'wifi-1-line',
  sizes: ['16', '24']
}, {
  name: 'Wifi2Line',
  fileName: 'wifi-2-line',
  sizes: ['16', '24']
}, {
  name: 'Wifi3Line',
  fileName: 'wifi-3-line',
  sizes: ['16', '24']
}, {
  name: 'Wifi4Line',
  fileName: 'wifi-4-line',
  sizes: ['16', '24']
}, {
  name: 'WifiErrorLine',
  fileName: 'wifi-error-line',
  sizes: ['16', '24']
}, {
  name: 'WifiOffLine',
  fileName: 'wifi-off-line',
  sizes: ['16', '24']
}, {
  name: 'WineFill',
  fileName: 'wine-fill',
  sizes: ['16', '24']
}, {
  name: 'WineLine',
  fileName: 'wine-line',
  sizes: ['16', '24']
}, {
  name: 'WrenchFill',
  fileName: 'wrench-fill',
  sizes: ['16', '24']
}, {
  name: 'WrenchLine',
  fileName: 'wrench-line',
  sizes: ['16', '24']
}, {
  name: 'ZoomInFill',
  fileName: 'zoom-in-fill',
  sizes: ['16', '24']
}, {
  name: 'ZoomInLine',
  fileName: 'zoom-in-line',
  sizes: ['16', '24']
}, {
  name: 'ZoomOutFill',
  fileName: 'zoom-out-fill',
  sizes: ['16', '24']
}, {
  name: 'ZoomOutLine',
  fileName: 'zoom-out-line',
  sizes: ['16', '24']
}];

export { iconDefinitions };
